package ru.villawonka.app

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.ExperimentalMaterialApi
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.navigator.CurrentScreen
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.bottomSheet.BottomSheetNavigator
import org.koin.core.context.startKoin
import ru.villawonka.app.common.extensions.toHexString
import ru.villawonka.app.data.di.dataModule
import ru.villawonka.app.domain.di.domainModule
import ru.villawonka.app.platform.di.platformModule
import ru.villawonka.app.platform.telegram.Telegram
import ru.villawonka.app.presentation.design.theme.AppTheme
import ru.villawonka.app.presentation.design.theme.overlay
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import ru.villawonka.app.presentation.di.presentationModule
import ru.villawonka.app.presentation.screens.settings.compose.SettingsScreen
import ru.villawonka.app.presentation.screens.splash.compose.SplashScreen

private var isAppInitialized = false

@OptIn(ExperimentalMaterialApi::class)
@Composable
fun App() {
    AppTheme {
        AppInit()
        BottomSheetNavigator(
            sheetBackgroundColor = MaterialTheme.colors.surfaceMiddle,
            scrimColor = MaterialTheme.colors.overlay,
            sheetShape = RoundedCornerShape(
                topStart = 32.dp,
                topEnd = 32.dp
            )
        ) {
            Navigator(
                screen = SplashScreen(
                    startParam = getTelegram()?.getInitDataUnsafe()?.startParam
                ),
            ) { navigator ->
                CurrentScreen()
                getTelegram()?.let { navigator.attachTelegramEventHandler(it) }
            }
        }
    }
}

@Composable
private fun AppInit() {
    if (isAppInitialized) return

    getSentry()?.init()
    initKoin()
    getTelegram()?.apply {
        ready()
        expand()
        disableVerticalSwipes()
        enableClosingConfirmation()
        lockOrientation()
        MaterialTheme.colors.surfaceMiddle.toHexString().let {
            setHeaderColor(it)
            setBottomBarColor(it)
            setBackgroundColor(it)
        }
    }

    isAppInitialized = true
}

private fun initKoin() {
    startKoin {
        modules(
            platformModule,
            dataModule,
            domainModule,
            presentationModule
        )
    }
}

@Composable
private fun Navigator.attachTelegramEventHandler(telegram: Telegram) {
    LaunchedEffect(Unit) {
        telegram.setSettingsButtonVisible(true)
        telegram.registerEventListener(Telegram.Event.OnSettingsButtonClicked)
        telegram.registerEventListener(Telegram.Event.OnBackButtonClicked)
        telegram.eventHandlerFlow.collect { event ->
            when (event) {
                is Telegram.Event.OnBackButtonClicked ->
                    pop()

                is Telegram.Event.OnSettingsButtonClicked ->
                    push(SettingsScreen())
            }
        }
    }
}